import {
    ACTIVATE_SECOND_SCREEN_ACTION,
    AMOUNT_ACTION,
    CARD_NUMBER_ACTION,
    CARD_PHOTO_ACTION,
    CARD_VERIFY_ACTION,
    CURRENCY_ACTION,
    DESTINATION_ACTION,
    EMAIL_ACTION,
    PAYWAY_ACTION,
    SWAP_CURRENCY_ACTION,
    VALIDATION_SECOND_SCREEN_ACTION,
    FILE_INPUT_ACTION,
    SCREEN_BACK_ACTION,
    FETCHING_ACTION,
    UPLOAD_CARD_PHOTO_ACTION,
    DESTINATION_TAG_ACTION,
    ORDER_LINK_ACTION,
    SHOW_EXAMPLE,
    LOADER_CUR_FROM
} from './type'

export function orderStatusAction (link) {
    return {
        type: ORDER_LINK_ACTION,
        link: link
    }
}

export function currencySelect (state) {
    return {
        type: CURRENCY_ACTION,
        state
    }
}

export function paywayAction (state, payway, minMaxLimits) {
    return {
        type: PAYWAY_ACTION,
        payway,
        minMaxLimits

    }
}

export function amountAction (amount, TimerId = null, amountValid = false, equivalentData = null) {
    return {
        type: AMOUNT_ACTION,
        amount,
        TimerId,
        amountValid,
        equivalentData,
    }
}

export function swapCurrencyButtonAction (state, swapCurrencyButtonName) {
    return {
        type: SWAP_CURRENCY_ACTION,
        swapCurrencyButtonName
    }
}

export function destinationAction (state, outDestination) {
    return {
        type: DESTINATION_ACTION,
        outDestination,
    }
}

export function destinationTagAction (state, outDestinationTag) {
    return {
        type: DESTINATION_TAG_ACTION,
        outDestinationTag
    }
}

export function emailAction (state, email) {
    return {
        type: EMAIL_ACTION,
        email
    }
}

export function cardNumberAction (state, cardData) {
    return {
        type: CARD_NUMBER_ACTION,
        cardData
    }
}

export function cardPhotoAction (state) {
    return {
        type: CARD_PHOTO_ACTION
    }
}

export function cardVerifyStatusAction (state, cardData, data) {
    return {
        type: CARD_VERIFY_ACTION,
        cardData: cardData,
        status: data.verificationStatus,
        firstName: data.firstName || null,
        lastName: data.lastName || null
    }
}

export function fileInputAction (state, fileData) {
    return {
        type: FILE_INPUT_ACTION,
        fileData
    }
}

export function uploadCardPhotoAction (state, response) {
    return {
        type: UPLOAD_CARD_PHOTO_ACTION,
        status: response.data.verificationStatus
    }
}

export function validationSecondScreenAction (state, destinationValid, emailMessage, cardValid) {
    return {
        type: VALIDATION_SECOND_SCREEN_ACTION,
        destinationValid,
        emailMessage,
        cardValid
    }
}

export function activateSecondScreenAction (state, feeData, exchangeRatesCurrencySide) {
    return {
        type: ACTIVATE_SECOND_SCREEN_ACTION,
        feeData,
        exchangeRatesCurrencySide
    }

}

export function screenBackAction (state) {
    return {
        type: SCREEN_BACK_ACTION,
    }
}

export function fetchingAction (state) {
    return {
        type: FETCHING_ACTION,
        isFetching: !state.isFetching
    }
}

export function showExampleAction () {
    return {
        type: SHOW_EXAMPLE
    }
}

export function loaderCurFromAction (loaderCurFrom) {
    return {
        type: LOADER_CUR_FROM,
        loaderCurFrom
    }
}